<div class="app-container">
  <header class="app-header" *ngIf="currentUser">
    <h1>🚀 Taptimize MK2</h1>
    <nav style="display: flex; align-items: center; gap: 1rem;">
      <!-- Simple navigation links -->
      <a routerLink="/dashboard">Dashboard</a> |
      <a routerLink="/inventory">Content Inventory</a>
      <!-- User info and logout -->
      <span style="margin-left: 1rem;">Welcome, {{ currentUser.name }}</span>
      <button (click)="logout()" style="margin-left: 1rem; padding: 0.5rem 1rem; background: #dc3545; color: white; border: none; border-radius: 4px; cursor: pointer;">Logout</button>
      <!-- Light/Dark mode toggle -->
      <button (click)="toggleTheme()" type="button" aria-label="Toggle light/dark mode" style="margin-left: 1rem; font-size: 1.2rem; background: none; border: none; color: var(--text-primary); cursor: pointer;">
        <span id="theme-toggle-icon">🌙</span>
      </button>
    </nav>
    <p *ngIf="!hasData">Analyze your Google Search Console data with ease</p>
  </header>
  <main>
    <app-upload *ngIf="currentUser && !hasData"></app-upload>
    <router-outlet *ngIf="!currentUser || hasData"></router-outlet>
  </main>
</div>
<!-- TODO: Replace CSV upload with direct GSC integration in the future -->


